import {
    Component,
    Inject,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedFacadeService } from '@emm/shared/services/shared-facade.service';
import { LanguageFormComponent } from '@emm/shared/components/language-form/language-form.component';

const SUBMIT_ORIGIN = 'dialog';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-language-dialog',
    styleUrls: ['./language-dialog.component.scss'],
    templateUrl: './language-dialog.component.html',
    standalone: false
})
export class LanguageDialogComponent implements OnInit {
    @ViewChild(LanguageFormComponent) languageForm: LanguageFormComponent;

    attributeSelectedLocales$ = this.sharedFacade.attributeSelectedLocales$;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<LanguageDialogComponent>,
        private sharedFacade: SharedFacadeService) {}



    ngOnInit(): void {
        const { attribute: { tag: attributeTag}, itemTag } = this.data;
        this.sharedFacade.getAttributeLocaleFields(itemTag, attributeTag);
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    handleSubmit(): void {
        const languageChanges = [];
        Object.keys(this.languageForm.form.controls).forEach(formField => {
            languageChanges.push({
                country: formField.toString().split('-')[1],
                language: formField.toString().split('-')[0],
                reset: this.languageForm.form.controls[formField].value === '',
                tag: this.languageForm.attributeSelected.tag,
                value: this.languageForm.form.controls[formField].value
            });
        });
        const data = {
            itemTag: this.languageForm.item.tag,
            languageChanges,
            origin: SUBMIT_ORIGIN
        }
        this.dialogRef.close(data);
    }



}
